<div class="row">
    <div class="col-12 col-md-3">
        <div class="card rounded-0" >
            <div class="card-body">
                <form #f="ngForm" (ngSubmit)="f.valid && submit()" novalidate>
                    <h3 class="fs-4 fw-bold">Integration</h3>
                    <div class="mb-3" *ngIf="!isCompanyIntegration()">
                        <label for="name" class="form-label">Name <em>*</em></label>
                        <input type="text" class="form-control" name="name" #name="ngModel" [(ngModel)]="data.name" required/>
                    </div>
                    <div class="mb-3">
                        <label for="provider" class="form-label">Provider <em>*</em></label>
                        <select class="form-control" name="provider" #provider="ngModel" [(ngModel)]="data.type" required (change)="getField($event)">
                            <option [value]="provider.type" *ngFor="let provider of providers">{{provider.name}}{{provider.integration_mode == 'company' ? ' (Tenant)' : provider.integration_mode == 'transfer' ? ' (Transfer)' : ''}}</option>
                        </select>
                    </div>
                    <div class="mb-3" *ngIf="!isCompanyIntegration()">
                        <label for="copy_text" class="form-label">Game Copy Text (Append at the end)</label>
                        <textarea class="form-control" id="copy_text" name="copy_text" #copy_text="ngModel" [(ngModel)]="data.copy_text" ></textarea>
                    </div>

                    <div *ngIf="fields.length > 0">
                        <p>API Setting</p>
                        <hr/>
                        <ng-container *ngFor="let field of fields">

                            <div [ngSwitch] = "field.type">

                                <div *ngSwitchCase = '6'><h3>Sample</h3></div>
                                
                                <div *ngSwitchDefault class="mb-3">
                                    <label [for]="field.key" class="form-label">{{field.title}} <em *ngIf="field.required !== false">*</em></label>
                                    <input [type]="field.type == 'password' ? 'password' : 'text'" class="form-control" [name]="field.key" [(ngModel)]="data.integration[field.key]" [required]="field.required !== false"/>
                                </div>
                                
                            </div>

                        </ng-container>
                        <hr/>

                    </div>
                    
                    
                    <div class="mb-3">
                        <label for="status" class="form-label">Status <em>*</em></label>
                        <select class="form-control" name="status" #status="ngModel" [(ngModel)]="data.status" required [disabled]="isFggPending()">
                            <option [value]="1" *ngIf="!isFggPending()">Enabled</option>
                            <option [value]="0">Disabled</option>
                        </select>
                        <small class="form-text text-muted" *ngIf="isFggPending()">FGG is awaiting provider testing and activation.</small>
                    </div>
                    <button type="submit" class="btn btn-primary">Save Integration</button>
                    <div class="mt-3" *ngIf="isCompanyIntegration() && data.type === 'ggx' && uuid">
                        <button type="button" class="btn btn-outline-info btn-sm" (click)="checkGgxBalance()" [disabled]="ggxBalanceLoading">
                            {{ ggxBalanceLoading ? 'Checking…' : 'Check Operator Balance' }}
                        </button>
                        <span class="ms-2" *ngIf="ggxBalance !== null">{{ ggxBalance }}</span>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>
